export default __webpack_public_path__ + "static/media/mastercard.17fcc34a.svg";